<script lang="ts">
    export let customerBalance: number | undefined;

    interface $$Slots {
        default: {
            customerBalance: number;
        };
    }
</script>

{#if customerBalance || customerBalance === 0}
    <slot {customerBalance} />
{/if}
